<app-header [hasHistoryCloseButton]="true" [title]="'APP_HISTORY'|translate" class="history-overlay-header" qaTag="history-overlay">
    <app-icon [svgIcon]="ICONS.TIMELINE"/>
</app-header>

<app-history-dashboard/>
